<template>
	<div class="activity-badge-layout">
		<slot></slot>
	</div>
</template>

<script>

export default {
	name: "ActivityBadgeLayout",
};
</script>

<style lang="scss" scoped>
.activity-badge-layout {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	width: 1.5rem;
	height: 1.5rem;
	border-radius: 1.5rem;

	@include font-and-line-for(0);
}
</style>
